export default "__VITE_ASSET__JlLtWWBM__"